import {
  IsDateString,
  IsNotEmpty,
  IsNumber,
  IsString,
  IsOptional,
  IsUUID,
  Min,
  Max,
  MaxLength,
  Matches,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Transform } from 'class-transformer'
import {
  MAX_PERIOD_NAME_LENGTH,
  DATE_FORMAT_REGEX,
  MIN_PERIOD_NUMBER,
  MAX_PERIOD_NUMBER,
} from '../../constants/academic-period.constants'

const toNumber = ({ value }: { value: any }) => {
  if (value === '' || value === null || value === undefined) return undefined
  return Number(value)
}

export class CreateAcademicPeriodDto {
  @ApiProperty({ type: 'string', description: 'ID de l\'établissement', example: '550e8400-e29b-41d4-a716-446655440000' })
  @IsNotEmpty({ message: 'L\'établissement est requis' })
  @IsUUID('4')
  establishmentId!: string

  @ApiProperty({ type: 'string', description: 'ID de l\'année scolaire', example: '550e8400-e29b-41d4-a716-446655440000' })
  @IsNotEmpty({ message: 'L\'année scolaire est requise' })
  @IsUUID('4')
  schoolYearId!: string

  @ApiProperty({ type: Number, description: 'Numéro de la période (1=Trimestre1, 2=Trimestre2, 3=Trimestre3)', example: 1, minimum: MIN_PERIOD_NUMBER, maximum: MAX_PERIOD_NUMBER })
  @IsNotEmpty({ message: 'Le numéro de période est requis' })
  @Transform(toNumber)
  @IsNumber()
  @Min(MIN_PERIOD_NUMBER)
  @Max(MAX_PERIOD_NUMBER)
  periodNumber!: number

  @ApiProperty({ type: 'string', description: 'Nom de la période', example: 'Trimestre 1', maxLength: MAX_PERIOD_NAME_LENGTH })
  @IsNotEmpty({ message: 'Le nom de la période est requis' })
  @IsString()
  @MaxLength(MAX_PERIOD_NAME_LENGTH)
  name!: string

  @ApiProperty({ type: 'string', description: 'Date de début (YYYY-MM-DD)', example: '2024-09-01' })
  @IsNotEmpty({ message: 'La date de début est requise' })
  @IsString()
  @Matches(DATE_FORMAT_REGEX, { message: 'Format de date invalide (attendu: YYYY-MM-DD)' })
  startDate!: string

  @ApiProperty({ type: 'string', description: 'Date de fin (YYYY-MM-DD)', example: '2024-12-20' })
  @IsNotEmpty({ message: 'La date de fin est requise' })
  @IsString()
  @Matches(DATE_FORMAT_REGEX, { message: 'Format de date invalide (attendu: YYYY-MM-DD)' })
  endDate!: string
}

export class UpdateAcademicPeriodDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'établissement' })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'année scolaire' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ type: Number, description: 'Numéro de la période', minimum: MIN_PERIOD_NUMBER, maximum: MAX_PERIOD_NUMBER })
  @IsOptional()
  @Transform(toNumber)
  @IsNumber()
  @Min(MIN_PERIOD_NUMBER)
  @Max(MAX_PERIOD_NUMBER)
  periodNumber?: number

  @ApiPropertyOptional({ type: 'string', description: 'Nom de la période', maxLength: MAX_PERIOD_NAME_LENGTH })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_PERIOD_NAME_LENGTH)
  name?: string

  @ApiPropertyOptional({ type: 'string', description: 'Date de début (YYYY-MM-DD)' })
  @IsOptional()
  @IsString()
  @Matches(DATE_FORMAT_REGEX, { message: 'Format de date invalide (attendu: YYYY-MM-DD)' })
  startDate?: string

  @ApiPropertyOptional({ type: 'string', description: 'Date de fin (YYYY-MM-DD)' })
  @IsOptional()
  @IsString()
  @Matches(DATE_FORMAT_REGEX, { message: 'Format de date invalide (attendu: YYYY-MM-DD)' })
  endDate?: string
}
